var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopicMedia = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@wheelroom/core");

exports.TopicMedia = function (props) {
  if (props.data.hideMedia) {
    return null;
  }

  var Media = null;
  var mediaProps = {};

  if (props.topicInfo.hasMediaBreakpoint && props.topic.mediaBreakpoint) {
    Media = core_1.MediaBreakpoint;
    var media = props.topic.mediaBreakpoint;
    mediaProps = {
      small: media === null || media === void 0 ? void 0 : media.small,
      medium: media === null || media === void 0 ? void 0 : media.medium,
      large: media === null || media === void 0 ? void 0 : media.large,
      extraLarge: media.extraLarge,
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.mediaBreakpoint
      })
    };
  } else if (props.topicInfo.hasImage && props.topic.media) {
    var _media = props.topic.media;
    Media = core_1.Image;
    mediaProps = {
      includeFigcaption: false,
      description: _media.description,
      media: props.topic.media,
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.image
      }),
      title: _media.title
    };
  } else if (props.topicInfo.hasVideo && props.topic.media) {
    var _media2 = props.topic.media;
    Media = core_1.Video;
    mediaProps = {
      includeTitle: false,
      includeDescription: false,
      description: _media2.description,
      media: _media2,
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.video
      }),
      title: _media2.title
    };
  } else if (props.topicInfo.hasMediaEmbed && props.topic.mediaEmbed) {
    Media = core_1.Embed;
    mediaProps = Object.assign(Object.assign({}, props.topic.mediaEmbed), {
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.embed
      })
    });
  }

  return react_1.default.createElement(core_1.Box, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.media
    })
  }, react_1.default.createElement(Media, Object.assign({}, mediaProps)));
};